const mergeFields = rawFields => {
  return rawFields.reduce( (merged, page) => [...merged, ...page.fields], []);
};

export const parseAllFields = ( rawFields ) => {
  // an array of paged results
  const mergedRawFields = mergeFields(rawFields);
  return mergedRawFields.reduce( (parsed, field) => {
    field.id = `${field.id}`; // force to string
    parsed.byId[field.id] = field;
    parsed.byUuid[field.uuid] = field;
    return parsed;
  }, { byId: {}, byUuid: {} });
};

